import { UserPublic, UsersPageParams } from 'api/model';
import instance from '../axios_instance';

const buildUsersQuery = ({ page, pageSize, sort, filters }: UsersPageParams): string => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('page_size', String(pageSize));
  sort?.forEach((field) => params.append('sort', field));
  filters?.forEach(({ field, operator, value }) => params.append('query', `${field}[${operator}]=${value}`));
  return params.toString();
};

export const getUsersPage = async (params: UsersPageParams): Promise<UserPublic[]> => {
  const response = await instance.get<UserPublic[]>(`/users?${buildUsersQuery(params)}`);
  return response.data;
};

export const deactivateUser = async (userId: string): Promise<UserPublic> => {
  const response = await instance.post<UserPublic>(`/users/${userId}/deactivate`);
  return response.data;
};

export const reactivateUser = async (userId: string): Promise<UserPublic> => {
  const response = await instance.post<UserPublic>(`/users/${userId}/reactivate`);
  return response.data;
};
